// https://github.com/ocsal/scroll-snap

import createScrollSnap from 'scroll-snap'

const ISMOBILE = window.matchMedia("only screen and (max-width: 992px)").matches
const element = document.getElementById('js-SingleSnap')

if(element && !ISMOBILE){
  createScrollSnap(element, {
    snapDestinationY: '100%',
    timeout: 100,
    duration: 200,
    threshold: 0.1,
    snapStop: false,
  })
}
